export const aboutCardStyles = {
  wrapper: {
    margin: {
      tablet: "0 2.5rem 7.5rem",
      laptop: "0 auto 7.5rem",
    },
    width: {
      laptop: "95vw",
      desktop: "unset",
    },
    maxWidth: {
      laptop: "69.438rem",
    },
    borderRadius: {
      tablet: "0.938rem",
    },
    overflow: {
      tablet: "hidden",
    },
  },
  cardContent: {
    position: "relative",
    textAlign: {
      mobile: "center",
      tablet: "left",
    },
    overflow: {
      mobile: "hidden",
      laptop: "unset",
    },
    zIndex: "1",
    padding: {
      mobile: "5rem 1.5rem 0",
      tablet: "4rem 3.62rem",
      laptop: "4rem 5.94rem",
    },
    mb: {
      mobile: "5rem",
      tablet: "unset",
    },
  },
  bgImage: {
    position: "absolute",
    top: {
      mobile: "-8.438rem",
      tablet: "-28rem",
      laptop: "-15rem",
    },
    right: {
      mobile: "0",
      tablet: "8.4rem",
      laptop: "5rem",
    },
    zIndex: "-1",
  },
};
